export const HTTP_RESPONSE_CODES = {
  OK: 200,
  UPDATED: 200,
  CREATED: 201,
  NO_CHANGE: 204,
  BAD_INPUT: 400,
  UNAUTHORIZED: 401,
  ACTION_NOT_ALLOWED: 403,
  ENTITY_NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

// localStorage key the `apiTransform` E2E fixture writes to (frontend/e2e/src/fixtures/index.ts),
// consumed by mocks/helpers.ts#response. Handlers that need to know whether a forced-failure
// override is active for the current request (e.g. to skip a mutation the override made moot)
// must read this same key — shared here so the two readers can't drift apart.
export const API_TRANSFORM_STORAGE_KEY = 'api-transform';
